module.exports = __webpack_public_path__ + "static/media/IN.947f1211.svg";